import { create } from "zustand";
import type { SignUpState } from "./types";

export const useSignUpStore = create<SignUpState>((set) => ({
  isLoading: false,
  errorMessage: null,
  phone: "",
  setPhone: (phone) => set({ phone }),
  setLoading: (loading) => set({ isLoading: loading }),
  setError: (message) => set({ errorMessage: message }),
  reset: () => set({ isLoading: false, errorMessage: null, phone: "" }),
}));
